import { render } from "./SponsorManageCreatePage.vue?vue&type=template&id=eb4f9724&lang=true"
import script from "./SponsorManageCreatePage.vue?vue&type=script&lang=js"
export * from "./SponsorManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__